import { withApiPrefix } from '../utils/apiBaseUrl';

const API = {
  API_BASE_URL: withApiPrefix(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL),
  CREATE_BUSINESS_ENDPOINT: '/business/create',
  LOGIN_USER_ENDPOINT: '/account/login',
  LOGOUT_USER_ENDPOINT: '/account/logout',
  UPLOAD_SIGNATURE_ENDPOINT: '/business/upload-signature',  // upload business signature
  UPLOAD_NCNDA_AGREEMENT_ENDPOINT: '/business/upload-ncnnda-agreement',
  UPLOAD_LOGO_ENDPOINT: '/business/upload-logo',  // upload business logo
  GET_BUSINESS_PROFILE: 'business/profile/',  // get business profile
  UPDATE_BUSINESS_PROFILE: 'business/',  // update business profile
  CREATE_CO_OWNER_PROFILE: '/co-owner/create',  // create co-owner account
  GET_ALL_CO_OWNERS: '/co-owner/getAll',  // get all co-owner
  DELETE_CO_OWNER: '/co-owner/delete/',  // delete co-owner
  UPDATE_CO_OWNER: '/co-owner/update/',  // update co-owner
  BLOCK_CO_OWNER: '/co-owner/block/', // block co-owner
  BUSINESS_PASSWORD_CHANGE: '/business/change-password/', // change business password
  CO_OWNER_INVITATION_LINK: '/business/invite-co-owner-link/', // co-owner invitation link
  VERIFY_TOKEN: '/account/verify-token', // verify invitation token
  CO_OWNER_ACCOUNT_REGISTER : '/account/register-co-owner', // create co-owner account
  SEND_REGISTER_INVITE_CO_OWNER: '/business/send-register-invite-co-owner', // register invite co-owner
  CO_OWNER_PASSWORD_CHANGE: '/co-owner/change-password/', // change co-owner password,
  GET_CO_OWNER_PROFILE: '/co-owner/profile/', //co-owner profile
  UPDATE_EMPLOYEE: '/employee/update/',
  GET_EMPLOYEE_PROFILE: '/employee/profile/',
  EMPLOYEE_PASSWORD_CHANGE: '/employee/change-password/',
  BLOCK_EMPLOYEE: '/employee/block/',
  DELETE_EMPLOYEE: '/employee/delete/',
  GET_ALL_EMPLOYEE: '/employee/getAll',
  CREATE_EMPLOYEE_PROFILE: '/employee/create',
  EMPLOYEE_INVITATION_LINK: '/employee/invite-employee-link/',
  SEND_REGISTER_INVITE_EMPLOYEE: '/employee/send-register-invite-employee', // register invite employee
  REGISTER_EMPLOYEE: '/account/register-employee', // register employee
  CREATE_CUSTOMER_PROFILE: '/customer/create', // create customer profile
  GET_ALL_CUSTOMER: '/customer/getAll', // get all the customer
  DELETE_CUSTOMER: '/customer/delete/', // delete customer
  UPDATE_CUSTOMER: '/customer/update/', // update customer
  BLOCK_CUSTOMER: '/customer/block/', // block customer
  CUSTOMER_PASSWORD_CHANGE: '/customer/change-password/', // customer password change
  GET_CUSTOMER_PROFILE: '/customer/profile/', // customer profile get
  CUSTOMER_INVITATION_LINK: '/customer/invite-customer-link/',
  SEND_REGISTER_INVITE_CUSTOMER: '/customer/send-register-invite-customer', // register invite customer
  REGISTER_CUSTOMER: '/account/register-customer', // register customer
  GET_ALL_LEAD: "/lead/getAll",
  CREATE_LEAD: "/lead/create",
  UPDATE_LEAD: "/lead/update",
  DELETE_LEAD: "/lead/delete",
  INVITE_LEAD: "/lead/invite",
  INVITE_USER_LEAD: "/lead/invite/",
  GET_INACTIVE_DEALS: "/customer/inactive-deals",
  USER_UPLOAD_SIGNATURE_ENDPOINT: '/account/upload-signature',  // upload user signature
  USER_UPLOAD_NCNDA_AGREEMENT_ENDPOINT: '/account/upload-ncnnda-agreement',
  LEAD_NOTE_CREATE: '/lead/notes/',  // lead notes create
  DELETE_LEAD_NOTE: '/lead/notes/', // lead note delete
  UPDATE_LEAS_NOTE: '/lead/note-update/', // lead note update
  PROSPECT_KYC_DOC_GET: '/prospect-kyc/',  // get all the prospect KYC document
  ADD_PROSPECT_KYC_DOC: '/prospect-kyc/',
  PROSPECT_KYC_FINANCIAL_FILE: '/prospect-kyc/', // appends :customerId/financial-info-file
  GET_CUSTOMER_BUSINESS_DOC: '/customer/business-doc/', // customer business document get
  GET_CUSTOMER_BUSINESS_DOC_FILE: '/customer/business-doc-file/', // signed business document preview/download
  CREATE_CUSTOMER_BUSINESS_DOC: '/customer/business-doc', // create customer business document after frontend Cloudinary upload
  CUSTOMER_BUSINESS_DOC_UPLOAD_SIGNATURE: '/customer/business-doc-upload-signature',
  UPLOAD_CUSTOMER_BUSINESS_DOC: '/customer/business-doc-upload',
  DELETE_BUSINESS_DOC: '/customer/business-doc-delete/', // business document delete
  CREATE_BANKER_PROFILE: '/banker/create', // create banker profile
  IMPORT_BANKERS: '/banker/import', // import bankers from Excel
  GET_ALL_BANKER: '/banker/getAll', // get all the banker
  DELETE_BANKER: '/banker/delete/', // delete banker
  UPDATE_BANKER: '/banker/update/', // update banker
  BLOCK_BANKER: '/banker/block/', // block banker
  // NOSONAR: This is an endpoint path, not a hardcoded password
  BANKER_PASSWORD_CHANGE_ENDPOINT: '/banker/change-password/', // banker credential change
  GET_BANKER_PROFILE: '/banker/profile/', // banker profile get
  BANKER_INVITATION_LINK: '/banker/invite-banker-link/',
  SEND_REGISTER_INVITE_BANKER: '/banker/send-register-invite-banker', // register invite banker
  REGISTER_BANKER: '/account/register-banker', // register banker
  CREATE_LOAN_REQUEST: '/customer/loan-request/', // Loan request create
  CREATE_BUSINESS_LOAN_REQUEST: '/customer/business-loan-request/', // Business loan request create
  GET_LOAN_REQUEST: '/customer/loan-request/', // Get single loan request
  UPDATE_LOAN_REQUEST: '/customer/loan-request/', //Loan request update
  UPDATE_LOAN_PROCEEDS: '/customer/loan-request/', // Update loan proceeds only (appends /:dealId/proceeds)
  UPDATE_LOAN_CLOSING: '/customer/loan-request/', // Update closing only (appends /:dealId/closing)
  GENERATE_TRANSACTION_SUMMARY: '/customer/loan-request/', // Generate Gemini transaction summary (appends /:dealId/generate-transaction-summary)
  DELETE_LOAN_REQUEST: '/customer/loan-request/', //Loan request delete
  GET_ALL_LOAN_REQUEST: '/customer/getAll-deals', //Loan request update
  GET_CUSTOMER_LOAN_REQUEST: '/customer/get-all-deals-customers', // get all loan request for a customer
  GET_CLOSING_ALERTS: '/customer/closing-alerts', // get due closing alerts
  GET_BANKER_REGISTER: '/banker/register', // get banker register
  CREATE_BANKER_REGISTER: '/banker/register', // create banker register
  GET_ALL_BANKER_REGISTER: '/customer/register-bankers', // get all banker register
  GET_BANKER_ASSIGNED_DEALS: '/banker/deals', // get banker assigned deals
  UPDATE_BANKER_INTEREST: '/banker/loan-request/', // update banker interest status
  ASSIGN_DEAL_BANKERS: '/customer/assign-bankers/', // assign deal bankers
  ASSIGN_DEAL_BANKERS_WITH_INVITES: '/customer/assign-bankers-with-invites/', // assign bankers and invite imported bankers
  GET_BANKS: '/banker/banks', // get all banks
  CREATE_BANK: '/banker/banks', // create bank
  GET_BANKER_DEAL_DETAILS: '/banker/deal-details/', // get banker deal details
  CREATE_BANKER_DOCUMENT: '/banker/deal-documents', // create banker document
  GET_BANKER_DOCUMENTS: '/banker/deal-documents/', // get banker documents for a deal
  DELETE_BANKER_DOCUMENT: '/banker/deal-documents/', // delete banker document
  CREATE_TERM_SHEET: '/banker/term-sheet',  // create term sheet
  GET_TERM_SHEET: '/banker/term-sheet/',  // get term sheet
  UPDATE_TERM_SHEET: '/banker/term-sheet/',  // update term sheet
  GET_TERM_SHEET_FOR_DEAL: '/customer/term-sheet/',  // get term sheet for deal
  GET_BANKER_DOCUMENTS_BY_BANKER: '/banker/deal-documents/',  // get banker documents by dealId and bankerId
  UPLOAD_CUSTOMER_DOCUMENT: '/customer/upload-customer-document/',  // upload customer document for a document ID
  GET_INBOX: '/inbox',  // get inbox for user
  GET_UNREAD_COUNT: '/inbox/unread-count',  // get unread count for user
  MARK_AS_READ: '/inbox',  // mark notification as read
  GET_ALL_BUSINESSES_ADMIN: '/admin/businesses',  // get all businesses for admin
  GET_BUSINESS_DETAILS_ADMIN: '/admin/business-details/',  // get business details for admin
  GET_CUSTOMER_DETAILS_ADMIN: '/admin/customer-details/',  // get customer details for admin
  SEND_RESET_EMAIL: '/account/send-reset-email',  // send reset email
  VERIFY_OTP: '/account/verify-otp',  // verify OTP
  RESET_PASSWORD: '/account/reset-password',  // reset password,
  SEND_VERIFICATION_EMAIL: '/account/send-verification-email',  // send registration email OTP
  VERIFY_EMAIL_OTP: '/account/verify-email-otp',  // verify registration email OTP
  GET_ALL_BANKERS_ADMIN: '/admin/bankers',  // get all bankers for admin
  GET_BANKER_DETAILS_ADMIN: '/admin/banker-details/',  // get banker details for admin
  GET_ACTIVITY_LOGS_ADMIN: '/admin/activity-logs',  // get activity logs for admin
  CUSTOMER_GET_BUSINESSES: '/customer/businesses',  // get customer businesses
  CUSTOMER_CREATE_BUSINESS: '/customer/businesses',  // create business
  CUSTOMER_UPDATE_BUSINESS: '/customer/businesses/',  // update business
  CUSTOMER_TAX_DATA: '/customer/tax-data/',  // get customer tax data for a year
  BUSINESS_DASHBOARD_DATA: '/business/dashboard-data',  // get business dashboard data
  BUSINESS_LINKEDIN_POST: '/business/social-posts/linkedin', // publish LinkedIn image post
  BUSINESS_LINKEDIN_AUTH_URL: '/business/social-posts/linkedin/auth-url', // LinkedIn OAuth URL
  BUSINESS_LINKEDIN_STATUS: '/business/social-posts/linkedin/status', // LinkedIn connection status
  BUSINESS_LINKEDIN_DISCONNECT: '/business/social-posts/linkedin', // disconnect LinkedIn account
  BUSINESS_INSTAGRAM_POST: '/business/social-posts/instagram', // publish Instagram image post
  BUSINESS_INSTAGRAM_AUTH_URL: '/business/social-posts/instagram/auth-url', // Instagram OAuth URL
  BUSINESS_INSTAGRAM_STATUS: '/business/social-posts/instagram/status', // Instagram connection status
  BUSINESS_INSTAGRAM_DISCONNECT: '/business/social-posts/instagram', // disconnect Instagram account
  TASKS: '/task', // business task manager
  LANDING_CONTACT_US: '/landing/contactUs', // contact us form submit
  LANDING_DEMO_REQUEST: '/landing/demoRequest', // demo request form submit
  LANDING_WAITLIST: '/landing/waitlist', // waitlist form submit
}

export default API;
